import Flickity from './wwdevFlickity';
import CustomFlickity from "./CustomFlickity";

class FlickityCarousel {
	constructor(config) {
		this.config = Object.assign({
			scope: '.flickity-carousel',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		new Promise((resolve) => {
			this.$scope.each((it, el) => {
				let settings = this.defaultSettings();

				Object.keys($(el).data()).forEach(function (key) {
					Object.assign(settings, {[key]: $(el).data(key)});
				});

				new Flickity(el, settings);
			});

			resolve(true);
		}).then(() => {
			new CustomFlickity();
		});
	}

	// Je kunt hier de standaard waardes aanpassen.
	defaultSettings() {
		return {
			cellAlign: 'left',
			contain: true,
			groupCells: true,
			arrowShape: 'M18.164 31.52a2.654 2.654 0 0 0-1.866.799L.768 48.139a2.654 2.654 0 0 0 .03 3.753L16.92 67.723a2.654 2.654 0 0 0 3.753-.041 2.654 2.654 0 0 0-.042-3.753l-11.507-11.3H97.36a2.632 2.632 0 0 0 2.633-2.634 2.632 2.632 0 0 0-2.633-2.633H8.958L20.082 36.03a2.654 2.654 0 0 0-.031-3.753 2.654 2.654 0 0 0-1.887-.757z'
		}
	}
}

export default FlickityCarousel;
